const $ = require('lib/jquery')
const template = require('./cookie_notice.html')
const styles = require('./cookie_notice.less')
const Bubble = require('module/bubble/bubble')
const viewer = require('module/viewer/viewer')
const viewport = require('module/viewport/viewport')
const log = require('log').create('cookie banner') // eslint-disable-line
require('plugin/cookie')

const COOKIE_NAME = 'accepted_cookies'

const CookieNotice = {

    initialize(options) {
        this.options = options

        // if the viewer has accepted, don't show the notice
        if (viewer.hasAction('accepted_cookies')) {
            // set the cookie so they don't have to see the notice again when
            // they logout
            this.setCookie()
            return
        }

        // if the cookie is set, don't show the notice
        if ($.cookie(COOKIE_NAME)) return

        // if this is an anonymous moble profile view, don't show the notice
        if (this.isAnonymousMobileProfileView()) return

        this.showNotice()
    },

    isAnonymousMobileProfileView() {
        if (viewer.is('logged_in')) return false
        if (viewport.isNot('small')) return false
        if (this.options.context.page.id !== 'profile') return false
        return true
    },

    setCookie() {
        if ($.cookie(COOKIE_NAME)) return
        $.cookie(COOKIE_NAME, true, {
            path: '/',
            // defaults to the current domain, works on mapped domains
            // domain: `.${g.DOMAIN_NAME}`,
            secure: window.location.hostname !== 'localhost',
        })
    },

    showNotice() {
        if (this.bubble) this.bubble.dismiss()

        this.bubble = new Bubble({
            html: template(),
            styles,
            duration: 0,
            close_button: false,
            close_on_escape: false,
        })
        this.bubble.$('button').one('click', () => {
            this.onClickButton()
        })
    },

    onClickButton() {
        if (viewer.is('logged_in')) {
            viewer.trackAction('accepted_cookies')
        }
        this.setCookie()
        this.bubble.dismiss()
    },

}

module.exports = CookieNotice
